import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import router from "@/router";
import useDate from "@/utils/hooks/useDate";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
} from "@vue/composition-api";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useReorderTable from "@/views/components/base-table/hooks/useReorderTable";
import useBaseTable from "@/views/components/base-table/hooks/useBaseTable";
export default function useCreateMappingBanner(props) {
  const { resolveDateWithSeperator } = useDate();
  const { openModal, closeModal } = useModal();
  const { openErrorModal } = useValidationModal();
  const { searchValue, onSetValueSearch } = useFilterHeaderTable();

  const {
    filters,
    ordering,
    loading,
    pagination,
    fields,
    tableData,
    actionTable,
    onPageChange,
    onFilterEntity,
    onSelectFilter,
  } = useBaseTable();

  const {
    currentIdSelect,
    currentIndex,
    keyChange,
    tableModeReorder,
  } = useReorderTable();
  const setMode = ref(false);

  const mappingSelect = ref(1);

  fields.value = [
    { key: "selected", label: "" },
    { key: "seq", label: "No." },
    { key: "banner_image_url", label: "Image" },
    { key: "banner_name", label: "Banner Name", sortable: true },
    { key: "call_to_action", label: "Call to Action" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through" },
    { key: "updatedtime", label: "Latest Update" },
    { key: "banner_status", label: "Status", sortable: true },
    { key: "actions", label: "" },
  ];

  const setBannerActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "EditIcon",
      display: true,
    },
    copy: {
      label: "Copy to",
      value: 2,
      icon: "CopyIcon",
      display: true,
    },
    move: {
      label: "Move to",
      value: 3,
      icon: "MoveIcon",
      display: true,
    },
    reorder: {
      label: "Reorder",
      value: 4,
      icon: "ReorderIcon",
      display: true,
    },
    delete: {
      label: "Delete",
      value: 5,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const setMappingBannerTable = reactive({
    column: [],
    payload: [],
    filterColumn: [],
    filter: [],
    isCreate: false,
  });

  const modalType = reactive({
    mapping: false,
    copy: false,
    move: false,
    reorder: false,
  });

  const modalConfig = reactive({ bannerId: null });

  const indexReorder = ref(null);

  const resolveBannerAction = (type, banner) => {
    switch (type) {
      case 1:
        editBanner(banner.item.banner_id);
        break;
      case 2:
        modalType.copy = true;
        modalConfig.bannerId = banner.item.banner_id;

        openModal();
        break;
      case 3:
        modalType.move = true;
        modalConfig.bannerId = banner.item.banner_id;

        openModal();
        break;
      case 4:
        modalType.reorder = true;
        openReorderModal(banner.index);
        break;
      case 5:
        resolveDeleteAction(banner.item);
        break;
      default:
        break;
    }
  };

  const resolveCloseModalAction = (type, data) => {
    switch (type) {
      case setBannerActionList.copy:
        break;
      case setBannerActionList.move:
        setMappingBannerTable.payload = JSON.parse(JSON.stringify(data));
        break;
      case setBannerActionList.reorder:
        break;
    }

    closeModal();

    setTimeout(() => {
      modalType.copy = false;
      modalType.move = false;
      modalType.reorder = false;
    }, 500);
  };

  const editBanner = (bannerId) => {
    const { params } = router.currentRoute;

    if (params.ref == "Banner_Group") {
      if (params.bannerGroupId) {
        return router.push(
          `/banner/group/Banner_Group/${params.bannerGroupId}/info/set/${params.setBannerId}/info/banner/${bannerId}/info`
        );
      }

      return router.push(
        `/banner/group/Banner_Group/set/${params.setBannerId}/info/banner/${bannerId}/info`
      );
    }
    return router.push(
      `/banner/set/Banner_Set/${params.setBannerId}/info/banner/${bannerId}/info`
    );
  };

  const openMappingModal = () => {
    modalType.mapping = true;
    setMode.value = true;
    openModal();
  };

  const closeMappingModal = () => {
    modalType.mapping = false;
    setMode.value = false;
    closeModal();
  };

  const openReorderModal = (index) => {
    modalType.reorder = true;
    indexReorder.value = index + 1;
    openModal();
  };

  const reorderArray = (arr, old_index, new_index) => {
    if (new_index >= arr.length || new_index < 0) {
      openErrorModal(
        "ทำรายการไม่สำเร็จ",
        `กรุณากรอกตัวเลขระหว่าง 1 - ${arr.length}`
      );
      return arr;
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  const reorderBanner = async (currentIndex, newIndex) => {
    reorderArray(setMappingBannerTable.payload, currentIndex - 1, newIndex - 1);

    keyChange.value++;
    closeModal();
  };

  const handleTableReorder = () => {
    setBannerActionList.reorder.display = !setBannerActionList.reorder.display;
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.value.disabled = !tableModeReorder.value;
  };

  const arrayMove = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  const handleRowChange = async (e) => {
    const arrTemp = setMappingBannerTable.payload;
    const arr = await arrayMove(
      arrTemp,
      e.oldDraggableIndex,
      e.newDraggableIndex
    );
    keyChange.value++;
    setMappingBannerTable.payload = arr;
  };

  const sortableRowOptions = ref({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: handleRowChange,
    disabled: true,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  const saveMappingBanner = () => {};

  const initMappingBanner = (mappingBannerList) => {
    let data = JSON.parse(JSON.stringify(mappingBannerList));
    data.map((o, index) => {
      if (o.banner_id != setMappingBannerTable.payload[index]?.banner_id) {
        setMappingBannerTable.payload.push({
          ...o,
          selected: false,
        });
      }
    });
    pagination.totalRows = setMappingBannerTable.payload.length;
    pagination.rows = setMappingBannerTable.payload.length;
  };

  const selectAllBanner = (isSelected) => {
    if (isSelected) {
      setMappingBannerTable.payload.map((banner) => {
        banner.selected = true;
      });
    }

    if (!isSelected) {
      setMappingBannerTable.payload.map((banner) => {
        banner.selected = false;
      });
    }

    keyChange.value++;
  };

  const clearAllBanner = () => {
    setMappingBannerTable.payload.map((banner) => {
      banner.selected = false;
      mappingSelect.value = false;
    });

    keyChange.value++;
  };

  const selectedAllBanner = () => {
    setMappingBannerTable.payload.map((banner) => {
      banner.selected = true;
      mappingSelect.value = true;
    });

    keyChange.value++;
  };

  const countBannerSelect = computed(() => {
    let selectFilter = setMappingBannerTable.payload.filter((o) => {
      return o.selected == true;
    });

    return selectFilter.length;
  });

  const hasSelectbanner = computed(() => {
    let selectFilter = setMappingBannerTable.payload.filter((o) => {
      return o.selected == true;
    });

    return selectFilter.length != 0;
  });

  const removeMappingBanner = () => {
    setMappingBannerTable.payload = setMappingBannerTable.payload.filter(
      (banner) => !banner.selected
    );

    keyChange.value++;
  };

  const resolveDeleteAction = (banner) => {
    setMappingBannerTable.payload = setMappingBannerTable.payload.filter(
      (mappedBanner) => mappedBanner.banner_id !== banner.banner_id
    );
  };

  onBeforeMount(() => {
    if (props.mappingBanner) {
      initMappingBanner(props.mappingBanner);
    }
  });

  watch(
    () => props.mappingBanner,
    () => {
      initMappingBanner(props.mappingBanner);
    },
    { deep: true }
  );

  return {
    fields,
    setMode,
    tableModeReorder,
    setMappingBannerTable,
    setBannerActionList,
    sortableRowOptions,
    keyChange,
    modalType,
    indexReorder,
    modalConfig,
    resolveDateWithSeperator,
    resolveBannerAction,
    closeMappingModal,
    openMappingModal,
    handleTableReorder,
    handleRowChange,
    saveMappingBanner,
    initMappingBanner,
    selectAllBanner,
    removeMappingBanner,
    resolveCloseModalAction,
    openReorderModal,
    reorderBanner,
    searchValue,
    onSetValueSearch,

    countBannerSelect,
    clearAllBanner,
    selectedAllBanner,
    mappingSelect,
    hasSelectbanner,
    pagination,
    onPageChange,
    onFilterEntity,
  };
}
